import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from 'ngx-toastr';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { provideTippyLoader, provideTippyConfig, tooltipVariation, popperVariation } from '@ngneat/helipopper/config';
import tippy from 'tippy.js';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideToastr(),
    provideRouter(routes),
    provideCharts(withDefaultRegisterables()),
    provideTippyLoader(() => tippy),
    provideTippyConfig({ theme: 'light', defaultVariation: 'tooltip', variations: { tooltip: tooltipVariation, popper: popperVariation } }),
  ]
};